module.exports = __webpack_public_path__ + "img/draw-lucky.00a3aa56.png";